import { NavLink } from "react-router-dom";
import { Home, MessageCircle, CalendarDays, Upload, Users, BookOpen } from "lucide-react";

const tabs = [
  { to: "/", label: "Home", icon: Home, id: "nav-home" },
  { to: "/chat", label: "Mia", icon: MessageCircle, id: "nav-chat" },
  { to: "/study", label: "Study", icon: BookOpen, id: "nav-study" },
  { to: "/calendar", label: "Calendar", icon: CalendarDays, id: "nav-calendar" },
  { to: "/upload", label: "Upload", icon: Upload, id: "nav-upload" },
  { to: "/parent", label: "Parent", icon: Users, id: "nav-parent" },
];

export const BottomNav = () => (
  <nav className="fixed bottom-0 left-0 right-0 border-t-2 border-black bg-white pb-safe pt-2 px-4 flex justify-around items-center z-50">
    {tabs.map(({ to, label, icon: Icon, id }) => (
      <NavLink
        key={to}
        to={to}
        end={to === "/"}
        data-testid={id}
        className={({ isActive }) =>
          `flex flex-col items-center gap-0.5 px-2 sm:px-4 py-1.5 mb-2 rounded-2xl transition-all ${
            isActive
              ? "bg-[#4D96FF] border-2 border-black shadow-[2px_2px_0px_rgba(0,0,0,1)] text-black"
              : "text-gray-500 hover:text-black"
          }`
        }
      >
        <Icon size={22} strokeWidth={2.5} />
        <span className="text-[10px] sm:text-xs font-bold">{label}</span>
      </NavLink>
    ))}
  </nav>
);
